/* Modules */
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, LOCALE_ID, APP_INITIALIZER } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxCarouselModule } from 'ngx-carousel';
import { SelectModule } from 'ng-select';
import localeTr from '@angular/common/locales/tr';

/* Main Components */
import { AppComponent } from './app.component';
import { MainSectionComponent } from './buyback-form/main-section/main-section.component';
import { FooterComponent } from './buyback-form/main-section/footer/footer.component';
import { RightSectionComponent } from './buyback-form/main-section/right-section/right-section.component';
import { AlertComponent } from './buyback-form/main-section/tabs/alert/alert.component';

/* Header Components */
import { HeaderComponent } from './buyback-form/main-section/header/header.component';
import { SuccessHeaderComponent } from './buyback-form/main-section/header/success-header/success-header.component';
import { NavigationTabsComponent } from './buyback-form/main-section/header/navigation-tabs/navigation-tabs.component';

/* Tab Components */
import { ZerothTabComponent } from './buyback-form/main-section/tabs/zeroth-tab/zeroth-tab.component';
import { FirstTabComponent } from './buyback-form/main-section/tabs/first-tab/first-tab.component';
import { SecondTabComponent } from './buyback-form/main-section/tabs/second-tab/second-tab.component';
import { ThirdTabComponent } from './buyback-form/main-section/tabs/third-tab/third-tab.component';
import { FourthTabComponent } from './buyback-form/main-section/tabs/fourth-tab/fourth-tab.component';
import { LastTabComponent } from './buyback-form/main-section/tabs/last-tab/last-tab.component';

/* Services */
import { DataService } from './buyback-form/main-section/shared/data.service';
import { FormDataService } from './buyback-form/main-section/shared/form-data.service';
import { RightSideService } from './buyback-form/main-section/shared/right-side.service';
import { AppLoadService } from './app-load.service';
import { NumberDirective } from './buyback-form/main-section/tabs/third-tab/numbers-only.directive';
import { NavigationBarService } from './buyback-form/main-section/shared/navigation-bar.service';
import { AppRoutingModule } from './app.routing.module';
import { registerLocaleData } from '@angular/common';

import { HealthCheck } from './health-check/health-check.component';

import {
  OnlySavedCategoryGuard,
  OnlySavedSecondTabGuard,
  OnlySavedSellerTabGuard,
  OnlySavedDeliveryTabGuard
} from './buyback-form/route-guard';
import { LettersOnlyDirective } from './buyback-form/main-section/tabs/third-tab/letters-only.directive';
import { AddressDirective } from './buyback-form/main-section/tabs/third-tab/address.directive';

registerLocaleData(localeTr, 'tr');

export function getSettings(appLoadService: AppLoadService) {
  return () => appLoadService.getToken();
}

@NgModule({
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    NgxCarouselModule,
    SelectModule,
    ReactiveFormsModule,
    BrowserAnimationsModule
  ],
  declarations: [
    AppComponent,
    FooterComponent,
    HeaderComponent,
    RightSectionComponent,
    MainSectionComponent,
    SuccessHeaderComponent,
    NavigationTabsComponent,
    ZerothTabComponent,
    FirstTabComponent,
    SecondTabComponent,
    ThirdTabComponent,
    FourthTabComponent,
    LastTabComponent,
    NumberDirective,
    LettersOnlyDirective,
    AddressDirective,
    AlertComponent,
    HealthCheck
  ],
  providers: [
    DataService,
    AppLoadService,
    { provide: APP_INITIALIZER, useFactory: getSettings, deps: [AppLoadService], multi: true },
    FormDataService,
    RightSideService,
    NavigationBarService,
    { provide: LOCALE_ID, useValue: 'tr' },
    OnlySavedCategoryGuard,
    OnlySavedSecondTabGuard,
    OnlySavedSellerTabGuard,
    OnlySavedDeliveryTabGuard,
  ],
  bootstrap: [AppComponent]
})


export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts